import { frontendURL } from '../../../../helper/URLHelper';

const ai = accountId => ({
  parentNav: 'ai-nav',
  routes: [
    'ai_list',
    // 'flows',
    'settings_account_campaigns_flow',
    'settings_account_campaigns_flow_edit',
    'expressBotList',
    'llm_bot_list',
    'llm_bot_add',
    'llm_bot_edit',
    'evaluation_list',
    'evaluation_report',
    'ai_tools',
    'ai_knowledge_base',
    'report_cost',
  ],
  menuItems: [
    {
      // add the icon with name as outline in "app\javascript\shared\components\FluentIcon\dashboard-icons.json"
      // real icon name with outline = "contact-card-group-outline"
      icon: 'box_3d',
      viewBox: '0 0 18 18',
      label: 'FLOW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/ai/flows`),
      toStateName: 'settings_account_campaigns_flow',
    },
    {
      key: 'expressBotList',
      icon: 'bot',
      label: 'EXPRESS_BOT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/ai/express-bots/list`),
      toStateName: 'expressBotList',
    },
    {
      key: 'llmBotList',
      icon: 'sound-source',
      label: 'LLM_BOTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/ai/llm-bots`),
      toStateName: 'llm_bot_list',
    },
    {
      key: 'aiEvaluationList',
      icon: 'document-checkmark',
      label: 'EVALUATIONS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/ai/evaluations`),
      toStateName: 'evaluation_list',
    },
    {
      key: 'aiTools',
      icon: 'wrench',
      label: 'AI_TOOLS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/ai/tools`),
      toStateName: 'ai_tools',
    },
    {
      key: 'aiKnowledgeBase',
      icon: 'book-globe',
      label: 'AI_KNOWLEDGE_BASE',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/ai/knowledge-base`),
      toStateName: 'ai_knowledge_base',
    },
    // {
    //   key: 'reportCost',
    //   icon: 'dollar-round',
    //   label: 'AI_REPORT_COSTS',
    //   hasSubMenu: false,
    //   toState: frontendURL(`accounts/${accountId}/ai/report-cost`),
    //   toStateName: 'report_cost',
    // },
  ],
});

export default ai;
